import { graphql } from '@/gql';
import type { CreateLocalTaxiScheduledRideMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createLocalTaxiScheduledRide = async ({
  phoneNumber,
  pickupDate,
  pickupTime,
  pickupAddress,
  dropoffAddress,
  rideType,
  notes,
  isMedicalTrip,
  partnerRidePurpose,
  returnTime,
}: CreateLocalTaxiScheduledRideMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateLocalTaxiScheduledRide(
        $phoneNumber: String!
        $pickupDate: String!
        $pickupTime: String!
        $pickupAddress: String!
        $dropoffAddress: String!
        $rideType: String!
        $notes: String
        $isMedicalTrip: Boolean
        $partnerRidePurpose: String
        $returnTime: String
      ) {
        createLocalTaxiScheduledRide(
          phoneNumber: $phoneNumber
          pickupDate: $pickupDate
          pickupTime: $pickupTime
          pickupAddress: $pickupAddress
          dropoffAddress: $dropoffAddress
          rideType: $rideType
          notes: $notes
          isMedicalTrip: $isMedicalTrip
          partnerRidePurpose: $partnerRidePurpose
          returnTime: $returnTime
        )
      }
    `),
    variables: {
      phoneNumber,
      pickupDate,
      pickupTime,
      pickupAddress,
      dropoffAddress,
      rideType,
      notes,
      isMedicalTrip,
      partnerRidePurpose,
      returnTime,
    },
  });

  return response.data?.createLocalTaxiScheduledRide ?? false;
};
